import { BRAND } from '@/lib/const';
import type { Brand } from '@/lib/types';
import { theme as breitlingTheme } from '@/theme';
import { galletTheme } from '@/theme/galletTheme';

import type { Theme } from './types';

const themes: { [key in Brand]: Theme } = {
  breitling: breitlingTheme,
  gallet: galletTheme,
};
//getTheme tests will throw error TypeError: (0 , _getTheme.getTheme) is not a function ,so I use const instead of function
export const theme = themes[BRAND];
